import { Typography } from "@mui/material";
import {Component} from "react";

export class ErrorComponent extends Component<{ error: any }> {
    render() {
        let {error} = this.props;
        return <Typography variant="h6">An Error Occurred: {error.errorCode}</Typography>;
    }
}